"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const MoreTabIcon = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 21 5" },
        react_1.default.createElement(react_native_svg_1.G, null,
            react_1.default.createElement(react_native_svg_1.Ellipse, { cx: "2.5", cy: "2.5", rx: "2.5", ry: "2.5", fillOpacity: "0", stroke: color }),
            react_1.default.createElement(react_native_svg_1.Ellipse, { cx: "10.5", cy: "2.5", rx: "2.5", ry: "2.5", fillOpacity: "0", stroke: color }),
            react_1.default.createElement(react_native_svg_1.Ellipse, { cx: "18.5", cy: "2.5", rx: "2.5", ry: "2.5", fillOpacity: "0", stroke: color }))));
};
MoreTabIcon.defaultProps = {
    color: 'rgb(148,148,148)',
    width: 21,
    height: 5,
};
exports.default = react_1.default.memo(MoreTabIcon);
